// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__2VJLR","title":"styles_title__3zo7E"};